import { Badge, Button } from "@material-ui/core";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { useTranslate } from "react-admin";

import { BoxesDialog } from "./BoxesDialog";

export const BoxesButton = ({
	record,
	isPickMode = false,
	isManualOrCombinedMode = true,
	pickedBoxIds = [],
	onPickBox,
	onUnpickBox,
	setBarcodeValue,
	setBarcodeTitle,
	setBarcodeDialogOpen,
}) => {
	const translate = useTranslate();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();

	if (!record?.boxes?.length) return null;

	return (
		<>
			<Badge badgeContent={isPickMode ? pickedBoxIds.length : 0} color="primary">
				<Button
					size="small"
					variant="contained"
					color="primary"
					onClick={(e) => {
						e.stopPropagation();
						handleOpen();
					}}
				>
					{translate("tab.pallets.boxes_button")}
				</Button>
			</Badge>
			<BoxesDialog
				open={open}
				onClose={handleClose}
				record={record}
				isPickMode={isPickMode}
				isManualOrCombinedMode={isManualOrCombinedMode}
				pickedBoxIds={pickedBoxIds}
				onPickBox={onPickBox}
				onUnpickBox={onUnpickBox}
				setBarcodeValue={setBarcodeValue}
				setBarcodeTitle={setBarcodeTitle}
				setBarcodeDialogOpen={setBarcodeDialogOpen}
			/>
		</>
	);
};
